export const SET_SHOULD_CRAWL_ONE_BY_ONE_URLS = 'SET_SHOULD_CRAWL_ONE_BY_ONE_URLS';
export const SET_CONTENT_METHOD = 'SET_CONTENT_METHOD';
export const SET_SHOULD_SHOW_REMOVE_VARIATION_MODAL = 'SET_SHOULD_SHOW_REMOVE_VARIATION_MODAL';
